<div class="header-container center-container space-between">
  <div i18n>分享到</div>
  <button appFocusRemove mat-dialog-close>
    <app-image-loading src="assets/icon_close.svg" alt="關閉" i18n-alt
                       [clickable]="true"
                       [targetWidth]="17"
                       [targetHeight]="17"/>
  </button>
</div>
<div class="center-container">
  <button class="column-container align-center margin-right" appFocusRemove (click)="shareFacebook()">
    <div class="img-border cursor-pointer center-container">
      <app-image-loading i18n-alt alt="Facebook" src="assets/icon_fb.svg"
                         [targetWidth]="imageSize"
                         [targetHeight]="imageSize"
                         [clickable]="true"/>
    </div>
    <div class="text" i18n>Facebook</div>
  </button>
  <button class="column-container align-center" appFocusRemove (click)="shareLine()">
    <div class="img-border cursor-pointer center-container">
      <app-image-loading i18n-alt alt="LINE" src="assets/icon_line.svg"
                         [targetWidth]="imageSize"
                         [targetHeight]="imageSize"
                         [clickable]="true"/>
    </div>
    <div class="text" i18n>LINE</div>
  </button>
</div>
